export default __webpack_public_path__ + "static/media/mh.b7938f97.jpg";